import axios, { AxiosResponse } from "axios"
// import { get } from "lodash-es"
import { Message } from "element-ui"
import { useUserStore } from "@/store/user"

const userStore = useUserStore()


export type ResponseData<T = unknown> =
  | { code: 0; data: T;[key: string]: unknown }
  | { code: number; msg: string }

const request = axios.create({
  timeout: 30000,
  baseURL:
    process.env.NODE_ENV === "development"
      ? process.env.VUE_APP_BASE_TARGET
      : process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
})

/* 请求拦截 */
request.interceptors.request.use((config) => {
  const { accessToken } = userStore.user
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}` || ""
  }

  return config
})

/* 相应拦截 */
request.interceptors.response.use(
  (response: AxiosResponse) => {
    const { status, config: { url } } = response
    const res = response.data

    const { code, data } = res
    const { refreshToken } = userStore.user

    if (code === 401 && refreshToken) {
      // token失效,重新刷新token
      refreshTokenRequest(refreshToken)
    }

    if (status !== 200 || code !== 0) {
      // 请求失败
      Message({
        type: "error",
        message: res.msg,
      })
      return Promise.reject(res)
    }


    /* 保存登录信息 */
    if (url === '/member-api/system/auth/login') {
      userStore.setUser(data)
    }

    return Promise.resolve(data)
  },
  (error) => {
    // if (get(error, "message", "").indexOf("timeout") !== -1) {
    if (error.message.includes('timeout')) {
      Message({
        type: "error",
        message: "请求超时",
      })
    }
    return Promise.reject(error)
  }
)


/* 刷新令牌 */
function refreshTokenRequest(refreshToken: string) {
  return request.post(`/member-api/system/auth/refresh-token?refreshToken=${refreshToken}`).then(response => {
    const { code, data, msg } = response.data

    if (code !== 0) {
      Message({
        type: "error",
        message: msg,
      })

      userStore.$reset()
      return Promise.reject(response.data)
    }

    userStore.setUser(data)
    return data
  }).catch(() => {
    userStore.$reset()
  })
}

export default request
